module.exports = __webpack_public_path__ + "static/img/comprehensive.684d25e4.svg";